import { render, staticRenderFns } from "./tempGajiKadarTetap.vue?vue&type=template&id=1aa58e5c&"
import script from "./tempGajiKadarTetap.vue?vue&type=script&lang=js&"
export * from "./tempGajiKadarTetap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports